export default function getResource(label, vars = []) {
    const resources = {
        compareProducts: 'Compare Products',
        emptySlot: 'Empty',
        unableToCompareProductsTitle: 'Unable To Compare Products',
        unableToCompareProductsMessage: 'Something went wrong. Please try again in a moment.',
        gotIt: 'Got It',
        colors: 'Colors',
        color: 'Color',
        sizes: 'Sizes',
        size: 'size',
        standardSize: 'Standard size: ',
        ratingsAndReviews: 'Rating & Reviews',
        prosMentioned: 'Pros Mentioned',
        consMentioned: 'Cons Mentioned',
        overview: 'Overview',
        ingredients: 'Ingredients',
        pickupAndDelivery: 'Pickup & Delivery',
        showAll: 'Show all',
        showLess: 'Show less',
        bopis: 'Buy Online & Pickup at ',
        gis: 'Get It Shipped: ',
        sdd: 'Same Day Delivery: ',
        setLocation: 'Set Location',
        inStock: 'In Stock',
        outOfStock: 'Out of Stock',
        onlineOnly: 'Online Only',
        storeOnly: 'In Store Only',
        goodFor: 'Good For',
        targetedConcerns: 'Targets Concerns',
        benefits: 'Benefits',
        removeProduct: 'Remove Product',
        openProductDetails: 'Open Product Details of',
        noValues: 'No values to compare',
        productInformation: `Product ${vars[0]} Information`,
        bopisSection: 'Buy Online & Pick Up:',
        gisSection: 'Get It Shipped:',
        sddSection: 'Same Day Delivery:',
        gisEmptyStatePrefix: 'Select to see delivery availability for ',
        gisEmptyStateBold: 'your location',
        bopisEmptyStatePrefix: 'Select to see pickup availability at ',
        bopisEmptyStateBold: 'stores near you'
    };

    return resources[label];
}
